<ng-container *ngIf="paragraph$ | async as data">
  <div
    [ngClass]="data['styleClass']"
    *ngIf="
      data['uid'] === 'ImportCSVSavedCartInstructionsComponent' ||
        data['uid'] === 'OrderInfoTitleComponent' ||
        data['uid'] === 'OrderDetailsTitleComponent';
      else elseBlock
    "
  >
    <div [innerHTML]="updateRelativePath(data['content'])"></div>
  </div>
  <ng-template #elseBlock>
    <div
      [ngClass]="data['styleClass']"
      *ngIf="
        (currentPageTemplate$ | async) !== 'MyAccountDiscountsPageTemplate' || !paragraphUid.includes('BucketType');
        else discountsPageTemplate
      "
    >
      <p [innerHTML]="updateRelativePath(data['content']) | safeHtml"></p>
    </div>
  </ng-template>
  <ng-template #discountsPageTemplate>
    <div
      [ngClass]="data['styleClass']"
      *ngIf="paragraphUid.includes('BucketType') && paragraphUid.includes(discountType)"
    >
      <p [innerHTML]="updateRelativePath(data['content'])"></p>
    </div>
  </ng-template>
</ng-container>
